export default "__VITE_ASSET__etJ5w9Qj__";